import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Dropdown from "react-bootstrap/Dropdown";
import Logoff from "../login/logoff";
import {
    Button,
    Modal,
    Form,
    Alert
  } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheck,
    faTimes,
  } from "@fortawesome/free-solid-svg-icons";
import t from "../../helpers/translator";
import { setSessionEnded } from "../../store/actions";
import apiCall from '../../helpers/api';


const Menu = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const auth = useSelector(state => state.user);
  const activeEvent = useSelector(state => state.activeEvent);

  // Form states
  const [email, setEmail] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [changePassword, setChangePassword] = useState(false);

  useEffect(() => {
    setActiveRoute(location.pathname);
  }, [location]);

  
  const [activeRoute, setActiveRoute] = useState("/users");
  const [showProfile, setShowProfile] = useState(false);

  // Menu items to display in navbar
  var menuItems = [];
  if (auth.user_type === "admin") {
    menuItems = [
        {
          title: "Users",
          icon: "users",
          route: "/users",
          active: activeRoute === "/users",
        },
        {
          title: "Templates",
          icon: "calendar",
          route: "/event-template-manager",
          active: activeRoute === "/event-template-manager",
        },
        {
          title: "Game Manager",
          icon: "puzzle-piece",
          route: "/game-manager",
          active: activeRoute === "/game-manager",
        },
      ];
    } else {
        menuItems = [
            {
              title: "Game Manager",
              icon: "puzzle-piece",
              route: "/game-manager",
              active: activeRoute === "/game-manager",
            },
          ];
    }

  const handleNavigate = (e, path) => {
    e.preventDefault();
    navigate(path);
  };

  // UI states
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });

  // Initialize form with user data
  useEffect(() => {
    if (auth) {
      setEmail(auth.email || "");
    }
  }, [auth]);

  const validateForm = () => {
    // Basic validation
    if (!email) {
      setMessage({ text: "Email is required", type: "danger" });
      return false;
    }

    if (!email.includes("@")) {
      setMessage({
        text: "Please enter a valid email address",
        type: "danger",
      });
      return false;
    }

    if (changePassword) {
      if (!currentPassword) {
        setMessage({ text: "Current password is required", type: "danger" });
        return false;
      }

      if (!newPassword) {
        setMessage({ text: "New password is required", type: "danger" });
        return false;
      }

      if (newPassword.length < 8) {
        setMessage({
          text: "New password must be at least 8 characters",
          type: "danger",
        });
        return false;
      }

      if (newPassword !== confirmPassword) {
        setMessage({ text: "Passwords do not match", type: "danger" });
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async () => {
    //e.preventDefault();

    // Clear previous messages
    setMessage({ text: "", type: "" });

    // Validate the form
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    // Prepare update data
    const updateData = {
      email,
    };

    // Add password data if changing password
    if (changePassword) {
      updateData.currentPassword = currentPassword;
      updateData.newPassword = newPassword;
    }

    // Make API call to update user profile
    apiCall({
      action: "users_update_profile",
      token: auth.token,
      data: updateData,
    })
      .then((response) => {
        if (response.error !== 0) {
          if (response.error === 99) {
            dispatch(setSessionEnded());
            return;
          }
          //show error message
          setMessage({ type: "danger", text: response.msg });
        } else {
          // Update user in Redux store
          dispatch({
            type: "UPDATE_USER",
            payload: { email },
          });
          // Reset password fields
          if (changePassword) {
            setCurrentPassword("");
            setNewPassword("");
            setConfirmPassword("");
            setChangePassword(false);
          }
          // Show success message
          setMessage({
            text: "Profile updated successfully!",
            type: "success",
          });
          // Close the modal with delay of 2 secs
            setTimeout(() => {
                setShowProfile(false);
                // Reset message
                setMessage({ text: "", type: "" });
            }, 2000);
        }
      })
      .catch((error) => {
        setMessage({
          text:
            error.message || "An error occurred while updating your profile",
          type: "danger",
        });
      })
      .finally(() => {
        // Reset loading state
        setIsLoading(false);
      });
  };

  return (
    <>
    <div className="d-flex flex-column" style={{ float: "right", paddingTop: "31px" }}>
      {/* Bootstrap Navbar */}
      <nav className="navbar navbar-expand navbar-light py-2">
      <div className="d-flex">
          {/* Horizontal Nav Links */}
          <div className="navbar-nav me-auto">
            {menuItems.map((item, index) => (
              //indien activeEvent = true dan menuItem .title = "Game Manager" en route = "/game-manager" niet tonen
                item.title === "Game Manager" && activeEvent ? 
                
                <React.Fragment key={item.route}>
                <a
                  className={`nav-link px-3 ${
                    activeRoute.substring(0,14) === "/event-manager" ? "fw-bold text-primary" : "text-dark"
                  }`}
                  href={item.route}
                  onClick={(e) => handleNavigate(e, item.route)}
                >
                  <i className={`fas fa-${item.icon} me-1 fa-sm`}></i>&nbsp;<span className="d-none d-md-inline">{t("Event Manager")}</span>
                </a>
                {index < menuItems.length && (
                  <div className="nav-link text-muted px-0">|</div>
                )}
              </React.Fragment>
                
                :

              <React.Fragment key={item.route}>
                <a
                  className={`nav-link px-3 ${
                    item.active ? "fw-bold text-primary" : "text-dark"
                  }`}
                  href={item.route}
                  onClick={(e) => handleNavigate(e, item.route)}
                >
                  <i className={`fas fa-${item.icon} me-1 fa-sm`}></i>&nbsp;<span className="d-none d-md-inline">{item.title}</span>
                </a>
                {index < menuItems.length && (
                  <div className="nav-link text-muted px-0">|</div>
                )}
              </React.Fragment>
            ))}
          
            {/* User Dropdown */}
            <Dropdown align="end" style={{paddingLeft: "18px", paddingTop: "4px"}}>
              <Dropdown.Toggle
                as="a"
                className="d-flex align-items-center text-decoration-none"
              >
                <div
                  className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                  style={{ width: "32px", height: "32px", fontSize: "1.2rem" }}
                >
                  {typeof auth.email !== "undefined" && auth.email.length > 0 ? auth.email.charAt(0).toUpperCase() : ''}
                </div>
                <span className="ms-2 d-none d-md-inline">{typeof auth.email !== "undefined" ? auth.email : ''}</span>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Header>Signed in as {auth.email}</Dropdown.Header>
                <Dropdown.Item href="#" onClick={() => setShowProfile(true)}>
                  <i className="fas fa-user me-2"></i>{t("Profile")}
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item href="#">
                  {/* <i className="fas fa-sign-out-alt me-2"></i>Sign out */}
                  <Logoff />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </nav>
    </div>

    {/* Confirmation Modal */}
    <Modal
    show={showProfile}
    onHide={() => setShowProfile(false)}
    centered
  >
    <Modal.Header closeButton>
      <Modal.Title>{t("Your profile")}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
    {message.text && (
                <Alert
                  variant={message.type}
                  dismissible
                  onClose={() => setMessage({ text: "", type: "" })}
                >
                  {message.text}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>{t("Email address")}</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={isLoading}
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Check
                    type="checkbox"
                    id="change-password"
                    label={t("Change password")}
                    checked={changePassword}
                    onChange={(e) => setChangePassword(e.target.checked)}
                    disabled={isLoading}
                  />
                </Form.Group>

                {changePassword && (
                  <div className="password-fields mb-4">
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Current Password")}</Form.Label>
                      <Form.Control
                        type="password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        disabled={isLoading}
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>{t("New Password")}</Form.Label>
                      <Form.Control
                        type="password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        disabled={isLoading}
                      />
                      <Form.Text className="text-muted">
                        {t("Password must be at least 8 characters long")}
                      </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>{t("Confirm New Password")}</Form.Label>
                      <Form.Control
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        disabled={isLoading}
                      />
                    </Form.Group>
                  </div>
                )}
            </Form>
    </Modal.Body>
    <Modal.Footer>
      <Button 
        variant="default" 
        onClick={() => setShowProfile(false)}
      >
        {t('Cancel')}
      </Button>
      <Button 
        variant="success" 
        onClick={() => handleSubmit(false)}
      >
        {t("Save changes")}
      </Button>
    </Modal.Footer>
  </Modal>
  </>
  );
};

export default Menu;
